import { useAuthStore } from "~/stores/auth";
import { useRouter } from "#imports";

export default defineNuxtPlugin((nuxtApp) => {
  const config = useRuntimeConfig();

  nuxtApp.provide(
    "fetchApi",
    async (
      url: string,
      options: { headers?: Record<string, string> } = {}
    ): Promise<any> => {
      const authStore = useAuthStore();
      const router = useRouter();
      const token = authStore.token;

      // Default headers and options
      const defaults = {
        baseURL: config.public.baseUrl as string,
        headers: {
          Authorization: token ? `Bearer ${token}` : "",
          ...options.headers,
        },
      };
      const mergedOptions = { ...defaults, ...options };

      const performFetch = async () => {
        const response = await useFetch(url, mergedOptions);
        return response.data.value; // Assuming you want the resolved data directly
      };

      try {
        return await performFetch();
      } catch (error: any) {
        // Handle 401 Unauthorized by refreshing the token
        if (error.response?.status === 401) {
          try {
            await authStore.refreshToken();
            const newToken = authStore.token;
            mergedOptions.headers.Authorization = `Bearer ${newToken}`;
            return await performFetch();
          } catch (refreshError) {
            console.error("Token refresh failed:", refreshError);
            authStore.clearToken();
            router.push("/login");
          }
        } else {
          throw error; // Rethrow other errors
        }
      }
    }
  );
});
